export const DEFAULT_TRADE_CONTACT = {
  departmentName: '',
  jobTitle: '',
  personName: '',
  universalCommunication: {
    email: '',
    phone: '',
  },
} as const;

export const INVALID_CONTACT_MESSAGE = 'Invalid contact information';
